export default class SwScrollInverter extends ContaoWebpack.Plugin {
	elements = [];

	init () {
        this.defaultRules = {
            img: {
                selector: (plugin, elem) => {
                    return elem.tagName.toLowerCase() === 'img';
                },
                invertType: 'light',
                priority: 4,
            },
            light: {
                selector: (plugin, elem) => {
                    return this.isDark(elem);
                },
                invertType: 'light',
                priority: 1,
            },
            dark: {
                selector: (plugin, elem) => {
                    return this.isLight(elem);
                },
                invertType: 'dark',
                priority: 1,
            }
        }

        this.options = {...{
            offsetX: -5,
            offsetY: 0,
            activatedRules: ['img', 'light', 'dark'],
            invertRules: [
                {
                    selector: (plugin, elem) => {
                        return elem.tagName.toLowerCase() === 'img';
                    },
                    invertType: 'light',
                    priority: 4,
                }
            ],
        }, ...this.options}

		this.scrollTimeout = setTimeout(() => {
			this.setupClasses()
		}, 1000)

		this.scrollTimeout = null;
		document.addEventListener('scroll', () => {
			this.setupClasses()

			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout)
			}

			this.scrollTimeout = setTimeout(() => {
				this.setupClasses()
			}, 300)
		});
	}

	getElementsFromPoint(el, conditionCallback) {
		do {
			if (el.nodeType !== 1) {
				break
			}
			if (conditionCallback(el)) {
				break
			}
		} while (el = el.parentNode)

		return el
	}

	setupClasses() {
		let elem = document.elementFromPoint(
                this.el.offsetLeft + this.options.offsetX,
                this.el.offsetTop + this.options.offsetY
            ),
            {r, g, b} = this.getColor(this.getElementColor(this.el))

		if (elem === null || elem.tagName === undefined) {
			return;
		}

		if (elem.tagName.toLowerCase() !== 'img' && (r == 0 || g == 0 || b == 0)) {
			elem = this.getElementsFromPoint(
				document.elementFromPoint(this.el.offsetLeft + this.options.offsetX, this.el.offsetTop + this.options.offsetY),
				(el) => {
					let {r, g, b} = this.getColor(window.getComputedStyle(el).backgroundColor);
					return (r > 0 || g > 0 || b > 0);
				}
			);
		}

		if (elem === null || elem.tagName === undefined) {
			return;
		}

        let invertType = {
            priority: 0,
            type: null
        };

        for (let rule of this.options.invertRules) {
            let selectorFunction = typeof rule.selector === 'string' ? window[rule.selector] : rule.selector;
            if (
                selectorFunction(this, elem) &&
                rule.priority >= invertType.priority
            ) {
                invertType.type = rule.invertType;
                invertType.priority = rule.priority;
            }
        }

		if (elem.tagName.toLowerCase() === 'img' || invertType.type === 'light') {
			this.addLightClass();
		} else if (invertType.type === 'dark') {
			this.addDarkClass();
		}
	}

	addLightClass() {
		if (!this.el.classList.contains('sw-light')) {
			this.el.classList.remove('sw-dark');
			this.el.classList.add('sw-light');
		}
	}

	addDarkClass() {
		if (!this.el.classList.contains('sw-dark')) {
			this.el.classList.remove('sw-light');
			this.el.classList.add('sw-dark');
		}
	}

	getColor(color) {
		let r, g, b;
		if (color.match(/^rgb/)) {
			color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

			r = color[1];
			g = color[2];
			b = color[3];
		} else {
			color = +("0x" + color.slice(1).replace(
			color.length < 5 && /./g, '$&$&'));

			r = color >> 16;
			g = color >> 8 & 255;
			b = color & 255;
		}

		return {r: r, g: g, b: b};
	}

    isDark(elem) {
        let hsp = this.getHsp(elem)
        return hsp < 127.5;
    }

    isLight(elem) {
        let hsp = this.getHsp(elem)
        return hsp > 127.5;
    }

    getElementColor(elem) {
        return window.getComputedStyle(elem).backgroundColor
    }

	getHsp(elem) {
		let hsp,
            color = this.getElementColor(elem)

		const {r, g, b} = this.getColor(color)

		hsp = Math.sqrt(
			0.299 * (r * r) +
			0.587 * (g * g) +
			0.114 * (b * b)
		)

        return hsp
	}
}
